import { createTheme, ITheme, MessageBar, PrimaryButton, ProgressIndicator, Separator, Stack, TextField } from '@fluentui/react';
import * as React from 'react';
import LoginIcon from '../../../Images/LoginLogo';
import { IStatusMessage } from '../../../Models/IStatusMessage';

interface IPasswordChangeViewProps {
    width: number
    isLoading: boolean;
    canSave: boolean;
    statusMessage?: IStatusMessage;
    oldPassword: string;
    newPassword: string;
    confirmPassword: string;
    onOldPassword: (password: string) => void;
    onNewPassword: (password: string) => void;
    onConfirmPassword: (password: string) => void;
    changePassword: () => void;
}



export const PasswordChangeView: React.FunctionComponent<IPasswordChangeViewProps> = (props) => {
    const oldPasswordChanged = (event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
        props.onOldPassword(newValue ? newValue : "");
    }
    const newPasswordChanged = (event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
        props.onNewPassword(newValue ? newValue : "");
    }
    const confirmPasswordChanged = (event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
        props.onConfirmPassword(newValue ? newValue : "");
    }
    const textBoxStyle = { subComponentStyles: { label: { root: { width: 105 } } } }
    return (<Stack horizontalAlign="center">
        <Stack tokens={{ childrenGap: 15 }} styles={{ root: { width: props.width, paddingTop:40 } }}>
            <Stack horizontalAlign="center" >
                <LoginIcon />
            </Stack>
            <Separator styles={{ root: { marginTop:0 } }}>Změna hesla</Separator>
            <Stack tokens={{ childrenGap: 15 }}>
                <TextField key="oldPassword" type="password" canRevealPassword required styles={textBoxStyle} value={props.oldPassword} onChange={oldPasswordChanged} label="Heslo" placeholder="Zadejte aktuální heslo" />
                <TextField key="password" type="password" canRevealPassword required styles={textBoxStyle} value={props.newPassword} onChange={newPasswordChanged} label="Nové heslo" placeholder="Zadejte nové heslo" />
                <TextField key="confirmPassword" type="password" canRevealPassword required styles={textBoxStyle} value={props.confirmPassword} onChange={confirmPasswordChanged} label="Potvrzení" placeholder="Potvrďte nové heslo" />
                <Stack styles={{ root: { paddingTop: 15 } }} horizontalAlign="center">
                    <PrimaryButton text="Uložit" onClick={props.changePassword} disabled={props.isLoading || !props.canSave} />
                </Stack>

                {props.isLoading ? <ProgressIndicator></ProgressIndicator> : null}
                {props.statusMessage && props.statusMessage.message ? <MessageBar styles={{ root: { marginTop: 20 } }} messageBarType={props.statusMessage.type}>{props.statusMessage.message}</MessageBar> : null}

            </Stack>
        </Stack>
    </Stack>)
}
